import React from 'react';
import { useSelector } from 'react-redux';

import VideoPlayer from '~video_player';
import { Modal } from '@common/ui/general';

import { fcSelector } from '@alumni_v2/selectors/reviews';
import RcbStrip from '../RcbStrip';

import styles from './VideoModal.module.scss';


const VideoModal = ({ onClose, videoLink, videoRef }) => {
  const { isFcModalOpen } = useSelector(fcSelector);

  return (
    <div className={styles.modalContainer}>
      <Modal
        isOpen={isFcModalOpen}
        position="center"
        size="extra-large"
        onClose={onClose}
        closeOnBackdropClick
        closeOnEscPress
        hasBackdrop
        withoutHeader
        className={styles.modal}
        containerClassName={styles.videoModal}
      >
        <VideoPlayer
          ref={videoRef}
          src={videoLink}
          poster={videoLink}
          className={styles.videoContainer}
        >
          <VideoPlayer.Controls />
        </VideoPlayer>
        <RcbStrip onClose={onClose} />
      </Modal>
    </div>
  );
};

export default VideoModal;
